/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  CreateBoxImportRuleRequestBody,
  CreateBoxImportRuleResponse,
  GetBoxImportRulesResponse,
  ImportRunResponse,
  UpdateBoxImportRuleRequestBody,
  UpdateBoxImportRuleResponse
} from '../model';

import getBoxImportRulesMutator from '../../../mutators/datastore-instance';
import createBoxImportRuleMutator from '../../../mutators/datastore-instance';
import updateBoxImportRuleMutator from '../../../mutators/datastore-instance';
import deleteBoxImportRuleMutator from '../../../mutators/datastore-instance';
import runBoxImportRuleMutator from '../../../mutators/datastore-instance';



  /**
 * 組織に登録された Box 取込ルールの一覧を更新日時の降順（updated_at DESC, id DESC）で取得します。
 * @summary Box 取込ルール一覧取得
 */
export const getBoxImportRules = (

 ) => {
      return getBoxImportRulesMutator<GetBoxImportRulesResponse>(
      {url: `/external-storages/box/import-rules`, method: 'GET'
    },
      );
    }
  /**
 * 組織に Box 取込ルールを 1 件作成します。ファイル取込時に Box への認証情報が必要となるため、組織の Box 接続情報が登録されていることが前提です。
 *
 * 書込先を指定する場合は `export_rule_id`（既存の書込ルールの紐付け）または `new_export_rule`（その場での新規作成と紐付け）のいずれか一方を指定します。
 * 一方を使う場合はもう一方のキーをボディに含めないでください。
 * 次のいずれかに該当する場合は 400 を返します。
 * `export_rule_id` と `new_export_rule` の同時指定、`export_rule_id` に指定した書込ルールが存在しない・組織外・保存時点で削除済み、`new_export_rule.name` が同一組織内で既に使われている。
 * `new_export_rule` で作成する書込ルールは取込ルールの保存と同一トランザクションで永続化し、保存に失敗した場合は作成されません。
 * @summary Box 取込ルール作成
 */
export const createBoxImportRule = (
    createBoxImportRuleRequestBody?: CreateBoxImportRuleRequestBody,
 ) => {
      return createBoxImportRuleMutator<CreateBoxImportRuleResponse>(
      {url: `/external-storages/box/import-rules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBoxImportRuleRequestBody
    },
      );
    }
  /**
 * 指定した Box 取込ルールを全項目置換で更新します。
 * ルールに対して待機中（scheduled）または実行中（running）の取込が存在する場合は 409 を返します。
 *
 * 書込先は `export_rule_id`（既存の書込ルールの紐付け）または `new_export_rule`（その場での新規作成と紐付け）のいずれか一方で指定します。
 * 一方を使う場合はもう一方のキーをボディに含めないでください。
 * いずれも指定しない場合は書込先の紐付けを解除します。既存の紐付けの置き換え・解除であり、以前紐付いていた書込ルール自体は削除されません。
 * 次のいずれかに該当する場合は 400 を返します。
 * `export_rule_id` と `new_export_rule` の同時指定、`export_rule_id` に指定した書込ルールが存在しない・組織外・保存時点で削除済み、`new_export_rule.name` が同一組織内で既に使われている。
 * `new_export_rule` で作成する書込ルールは取込ルールの更新と同一トランザクションで永続化します。
 * @summary Box 取込ルール更新
 */
export const updateBoxImportRule = (
    id: number,
    updateBoxImportRuleRequestBody?: UpdateBoxImportRuleRequestBody,
 ) => {
      return updateBoxImportRuleMutator<UpdateBoxImportRuleResponse>(
      {url: `/external-storages/box/import-rules/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateBoxImportRuleRequestBody
    },
      );
    }
  /**
 * 指定した Box 取込ルールを物理削除します。
 * 紐づく取込履歴も連鎖削除されます。
 * ルールに対して待機中（scheduled）または実行中（running）の取込が存在する場合は 409 を返します。
 * @summary Box 取込ルール削除
 */
export const deleteBoxImportRule = (
    id: number,
 ) => {
      return deleteBoxImportRuleMutator<void>(
      {url: `/external-storages/box/import-rules/${id}`, method: 'DELETE'
    },
      );
    }
  /**
 * 指定した Box 取込ルールの手動取込を実行します。
 * 取込実行レコードを作成し、external-storage-importer キューに投入します。
 * 同一ルールに対して実行中の取込が存在する場合は 409 を返します。
 * @summary Box 取込ルール手動取込実行
 */
export const runBoxImportRule = (
    id: number,
 ) => {
      return runBoxImportRuleMutator<ImportRunResponse>(
      {url: `/external-storages/box/import-rules/${id}/runs`, method: 'POST'
    },
      );
    }
  export type GetBoxImportRulesResult = NonNullable<Awaited<ReturnType<typeof getBoxImportRules>>>
export type CreateBoxImportRuleResult = NonNullable<Awaited<ReturnType<typeof createBoxImportRule>>>
export type UpdateBoxImportRuleResult = NonNullable<Awaited<ReturnType<typeof updateBoxImportRule>>>
export type DeleteBoxImportRuleResult = NonNullable<Awaited<ReturnType<typeof deleteBoxImportRule>>>
export type RunBoxImportRuleResult = NonNullable<Awaited<ReturnType<typeof runBoxImportRule>>>
